module.exports = __webpack_public_path__ + "static/media/026.3c3e7fec.jpg";